import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

const Recommendations = ({ recommendations, title }) => {
  const theme = useContext(ThemeContext);

  return (
    <div className="container">
      <h3>Similar to {title}</h3>
      <ul className="recommendations-container">
        {recommendations.map((item) => (
          <a href={item.url} key={item.id}>
            {item.displayName}
          </a>
        ))}
      </ul>

      <style jsx>{`
        .container {
          text-align: center;
        }
        .container h3 {
          font-size: 20px;
        }
        .recommendations-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          padding: 10px;
        }
        .recommendations-container a {
          color: ${theme.colors.breadcrumbhover};
          display: block;
          font-weight: bold;
          padding: 10px;
          text-align: center;
          text-decoration: none;
          width: 25%;
        }
        .recommendations-container a:hover {
          color: #333;
        }
      `}</style>
    </div>
  );
};

export default Recommendations;

Recommendations.propTypes = {
  recommendations: PropTypes.array,
  title: PropTypes.string,
};
